import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-wallet.png';

const Footer = () => (
  <footer className="border-t border-gray-200 pt-8 pb-4 text-gray-500 text-sm bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 items-start mb-4">
        {/* Column 1: Logo and description */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <img src={logo} alt="SignatureForward - Free email signature generator and creator for Gmail, Outlook, and business email" className="h-8 w-auto mb-4" />
          <div className="mb-2">SignatureForward is a web based platform to create and manage professional headshots and email signatures for individuals and organizations.</div>
        </div>
        {/* Column 2: Products */}
        <div className="flex flex-col gap-2 items-center md:items-start text-center md:text-left">
          <span className="font-semibold text-gray-700 mb-1">Products</span>
          <Link to="/generator" className="text-gray-500 hover:text-gray-700 transition-colors">Email Signature Generator</Link>
          <Link to="/wallet-passes" className="text-gray-500 hover:text-gray-700 transition-colors">Wallet Passes</Link>
          <Link to="/loyalty" className="text-gray-500 hover:text-gray-700 transition-colors">Loyalty Programs</Link>
          <Link to="/digital-business-cards" className="text-gray-500 hover:text-gray-700 transition-colors">Digital Business Cards</Link>
        </div>
        {/* Column 3: Company */}
        <div className="flex flex-col gap-2 items-center md:items-start text-center md:text-left">
          <span className="font-semibold text-gray-700 mb-1">Company</span>
          <Link to="/support" className="text-gray-500 hover:text-gray-700 transition-colors">Support</Link>
          <Link to="/privacy-policy" className="text-gray-500 hover:text-gray-700 transition-colors">Privacy Policy</Link>
          <Link to="/terms-and-conditions" className="text-gray-500 hover:text-gray-700 transition-colors">Terms & Conditions</Link>
        </div>
        {/* Column 4: Useful Links */}
        <div className="flex flex-col gap-2 items-center md:items-start text-center md:text-left">
          <span className="font-semibold text-gray-700 mb-1">Useful Links</span>
          <Link to="/pricing" className="text-gray-500 hover:text-gray-700 transition-colors">Pricing</Link>
          <Link to="/contact-us" className="text-gray-500 hover:text-gray-700 transition-colors">Contact Us</Link>
          <Link to="/blog" className="text-gray-500 hover:text-gray-700 transition-colors">Blog</Link>
          <Link to="/feedback-roadmap" className="text-gray-500 hover:text-gray-700 transition-colors">Feedback/Roadmap</Link>
        </div>
      </div>
      <div className="text-center text-gray-400 text-xs mt-8">© Copyright 2025, All Rights Reserved by SignatureForward</div>
    </div>
  </footer>
);

export default Footer; 